<template>
  <div class="m-4">
    <div class="card w-full">
      <Tabs
        :value="route.path"
        class="w-full"
      >
        <TabList class="w-full">
          <Tab
            v-for="tab in items"
            :key="tab.label"
            :value="tab.route"
          >
            <router-link
              v-slot="{ href, navigate }"
              :to="tab.route"
              custom
            >
              <a
                v-ripple
                :href="href"
                class="flex items-center gap-2 text-inherit"
                @click="navigate"
              >
                <i :class="tab.icon" />
                <span>{{ tab.label }}</span>
              </a>
            </router-link>
          </Tab>
        </TabList>
      </Tabs>

      <!-- Content slot with full width -->
      <div class="mt-4 w-full">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

// Define the tab items with icons
const items = ref([
    {
        route: '/crewing/crew',
        label: 'Crew',
        icon: 'pi pi-users'  // Users icon for crew
    },
    {
        route: '/crewing/crew-types',
        label: 'Crew Types',
        icon: 'pi pi-id-card'  // ID card icon for crew types
    }
]);
</script>

<style scoped>
/* Add any custom styling if needed */
.text-inherit {
    color: inherit;
    text-decoration: none;
}

.items-center {
    align-items: center;
}

.flex {
    display: flex;
}

.gap-2 {
    gap: 0.5rem;
}

/* Ensure card takes full width */
.card {
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

/* Ensure tab content can be full width */
:deep(.p-tabview-panels) {
    width: 100%;
}
</style>